var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _ParameterFieldAdapters_set, _ParameterFieldAdapters_writeNotifier, _ParameterFieldAdapters_tracksMap, _ParameterFieldAdapters_modeMap;
import { Notifier, Option } from "@opendaw/lib-std";
import { Address } from "@opendaw/lib-box";
export class ParameterFieldAdapters {
    constructor() {
        _ParameterFieldAdapters_set.set(this, void 0);
        _ParameterFieldAdapters_writeNotifier.set(this, void 0);
        _ParameterFieldAdapters_tracksMap.set(this, void 0);
        _ParameterFieldAdapters_modeMap.set(this, void 0);
        __classPrivateFieldSet(this, _ParameterFieldAdapters_set, Address.newSet(adapter => adapter.field.address), "f");
        __classPrivateFieldSet(this, _ParameterFieldAdapters_writeNotifier, new Notifier(), "f");
        __classPrivateFieldSet(this, _ParameterFieldAdapters_tracksMap, new Map(), "f");
        __classPrivateFieldSet(this, _ParameterFieldAdapters_modeMap, new Map(), "f");
    }
    register(adapter) {
        __classPrivateFieldGet(this, _ParameterFieldAdapters_set, "f").add(adapter);
        return { terminate: () => __classPrivateFieldGet(this, _ParameterFieldAdapters_set, "f").removeByValue(adapter) };
    }
    get(address) { return __classPrivateFieldGet(this, _ParameterFieldAdapters_set, "f").get(address, "parameter field adapter"); }
    opt(address) { return __classPrivateFieldGet(this, _ParameterFieldAdapters_set, "f").opt(address); }
    registerTracks(address, tracks) {
        const key = address.toString();
        __classPrivateFieldGet(this, _ParameterFieldAdapters_tracksMap, "f").set(key, tracks);
        return { terminate: () => __classPrivateFieldGet(this, _ParameterFieldAdapters_tracksMap, "f").delete(key) };
    }
    getTracks(address) {
        return Option.wrap(__classPrivateFieldGet(this, _ParameterFieldAdapters_tracksMap, "f").get(address.toString()));
    }
    setMode(address, mode) { __classPrivateFieldGet(this, _ParameterFieldAdapters_modeMap, "f").set(address.toString(), mode); }
    getMode(address) { return __classPrivateFieldGet(this, _ParameterFieldAdapters_modeMap, "f").get(address.toString()) ?? "read"; }
    subscribeWrites(observer) {
        return __classPrivateFieldGet(this, _ParameterFieldAdapters_writeNotifier, "f").subscribe(observer);
    }
    notifyWrite(adapter, previousUnitValue) {
        __classPrivateFieldGet(this, _ParameterFieldAdapters_writeNotifier, "f").notify({ adapter, previousUnitValue });
    }
}
_ParameterFieldAdapters_set = new WeakMap(), _ParameterFieldAdapters_writeNotifier = new WeakMap(), _ParameterFieldAdapters_tracksMap = new WeakMap(), _ParameterFieldAdapters_modeMap = new WeakMap();
